import { compareStreamId, isStreamId } from '@/utils/stream.id';
import type { TypeOpsLogEntry } from '@/types/ops/types.ops.log';

export function opsLogsMerge(current: readonly TypeOpsLogEntry[], incoming: readonly TypeOpsLogEntry[] | undefined, window: number): TypeOpsLogEntry[] {
    if (!incoming?.length) return current as TypeOpsLogEntry[];

    const last = current.length ? current[current.length - 1].id : null;
    const fresh = incoming.filter((entry) => entry && isStreamId(entry.id));
    const appendOnly = last !== null && fresh.every((entry) => compareStreamId(entry.id, last) > 0);

    let merged: TypeOpsLogEntry[];
    if (appendOnly) {
        merged = [...current, ...fresh];
    } else {
        const byId = new Map<string, TypeOpsLogEntry>();
        for (const entry of current) byId.set(entry.id, entry);
        for (const entry of fresh) byId.set(entry.id, entry);
        merged = [...byId.values()].sort((a, b) => compareStreamId(a.id, b.id));
    }

    return merged.length > window ? merged.slice(merged.length - window) : merged;
}

export default opsLogsMerge;
